<!-- biome-ignore-all lint/a11y/noStaticElementInteractions: no handler; the bare .stop modifier only keeps the row click from firing when toggling the checkbox -->
<!-- biome-ignore-all lint/a11y/useKeyWithClickEvents: no action is triggered, so there is nothing to bind to a key -->
<script setup lang="ts">
  import { computed } from 'vue';
  import { Checkbox } from '@tundr/ds-components';
  import { useLocale } from '@tundr/i18n';
  import { selectionCheckboxClass } from './InternalDataTable.css';

  const props = defineProps<{
    status: 'noneSelected' | 'partSelected' | 'allSelected';
  }>();

  const emits = defineEmits<{ change: [value: boolean] }>();

  const { t } = useLocale('table');

  const isChecked = computed(() => props.status === 'allSelected');
</script>

<template>
  <div :class="['internal-checkbox', selectionCheckboxClass]" @click.stop>
    <Checkbox
      :model-value="isChecked"
      :indeterminate="status === 'partSelected'"
      :aria-label="t('table.select_all')"
      @update:model-value="(value) => emits('change', value)"
    />
  </div>
</template>
